import { jsx as _jsx } from "react/jsx-runtime";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Alert } from "antd";
import { useTranslation } from "../../../../others/i18n.js";
/**
 * Alert display to indicate validations for releasable templates.
 */ const ReleaseValidationNotice = (props)=>{
    const { t } = useTranslation();
    const { hidden } = props;
    return /*#__PURE__*/ _jsx("div", {
        hidden: hidden,
        children: /*#__PURE__*/ _jsx(Alert, {
            message: t("Some templates have validation errors. Please fix them in order to be able to create a release!"),
            type: "error",
            showIcon: true,
            icon: /*#__PURE__*/ _jsx(ExclamationCircleOutlined, {
                style: {
                    color: "red",
                    textAlign: "center"
                }
            }),
            ...props
        })
    });
};
export { ReleaseValidationNotice };
